import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { AppPreset } from './app.theme';
import { provideServiceWorker } from '@angular/service-worker';
import { locale } from './app.locale';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes), 
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({ 
      translation: locale['sr-RS'],
      ripple: true,
      theme: {
        preset: AppPreset,
        options: {
          darkModeSelector: '.doc-app-dark',
        }
      }
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true, // disabled in development mode !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ]
};
